import React from "react";

import { Wrapper } from "./Text.styles";
const Text = ({text}) => (

    <Wrapper>
       <div>{text}</div>
    </Wrapper>


);

export default Text;